export default __webpack_public_path__ + "static/media/one.acde9af4.png";